module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view start-view"
  }, [(_vm.hasDisCookie === false) ? _c('div', {
    staticClass: "cookiepop",
    attrs: {
      "id": "cookie-dis"
    }
  }, [_vm._v("Vi använder cookies för att ge dig bästa möjliga upplevelse. Genom att använda webbplatsen accepterar du att cookies används. "), _vm._m(0), _c('div', {
    staticClass: "cookie-close",
    on: {
      "click": _vm.closeCookie
    }
  }, [_vm._v("✕")])]) : _vm._e(), _vm._v(" "), (true === false) ? _c('div', {
    staticClass: "section",
    attrs: {
      "id": "collage"
    }
  }, _vm._l((_vm.winnerSlides), function(slide, index) {
    return _c('div', {
      staticClass: "collage-item",
      style: ({
        backgroundImage: 'url(' + './static/min/' + slide.image + ')',
        top: (_vm.getRandomPos(index))[0] + 'px',
        left: (_vm.getRandomPos(index))[1] + 'px',
        height: (_vm.getRandomSize(index))[1] + 'px',
        width: (_vm.getRandomSize(index))[0] + 'px'
      })
    })
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "table-cell start-section"
  }, [_c('div', {
    staticClass: "smile smile-crown"
  }), _vm._v(" "), _c('div', {
    staticClass: "smile smile-crop"
  }), _vm._v(" "), _c('div', {
    staticClass: "smile smile-key"
  }), _vm._v(" "), _c('div', {
    staticClass: "smile smile-sun"
  }), _vm._v(" "), _c('div', {
    staticClass: "smile smile-camera"
  }), _vm._v(" "), _c('div', {
    staticClass: "smile smile-levers"
  }), _vm._v(" "), _c('div', {
    staticClass: "smile smile-squares"
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-40"
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  }), _vm._v(" "), _c('div', {
    staticClass: "exs-title"
  }, [_vm._v("\r\n              Exhibition\r\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "exs-sub-title"
  }, [_vm._v("\r\n              Stockholm\r\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "new-logo"
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "blue-butt",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "to": "/winners"
    }
  }, [_vm._v("Se utställda foton 2017")]), _c('br'), _c('br')], 1)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "padding-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "winner-slides"
  }, _vm._l((_vm.winnerSlides), function(slide) {
    return _c('div', {
      staticClass: "winner-slide",
      style: ({
        backgroundImage: 'url(' + './static/min/' + slide.image + ')'
      })
    }, [_c('div', {
      staticClass: "winner-text"
    }, [_c('div', {
      staticClass: "blue-circle"
    }), _vm._v(" "), _c('span', {
      staticClass: "spot-title"
    }, [_vm._v(_vm._s(slide.spot))]), _vm._v(" av "), _c('b', [_vm._v(_vm._s(slide.username))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "inner-grid content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "iphone-mockup"
  }), _vm._v(" "), _c('div', {
    staticClass: "badge-group"
  }, [_c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.adobe.lrmobile",
      "target": "_blank"
    },
    on: {
      "click": _vm.toGooglePlay
    }
  }, [_c('div', {
    attrs: {
      "id": "google-badge"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://appsto.re/se/EXsy0.i",
      "target": "_blank"
    },
    on: {
      "click": _vm.toAppStore
    }
  }, [_c('div', {
    attrs: {
      "id": "ios-badge"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "section start-bottom"
  }, [_c('div', {
    staticClass: "padding-20"
  }), _vm._v(" "), _c('ul', {
    staticClass: "bottom-menu"
  }, [_c('li'), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.openRegler
    }
  }, [_vm._v("Tävlingsregler & poäng")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.openTerms
    }
  }, [_vm._v("Användar- & tävlingsvillkor")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.openSupport
    }
  }, [_vm._v("Support")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.openOm
    }
  }, [_vm._v("Om Adobe")])]), _vm._v(" "), _c('br'), _vm._v("\r\n        Adobe 2017\r\n      ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://www.adobe.com/se/privacy/cookies.html",
      "target": "_blank"
    }
  }, [_c('u', [_vm._v("Läs mer här")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section white-section",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "inner-grid"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', [_vm._v("\r\nTusentals fantastiska bilder laddades upp till Exhibition Stockholm. I den digitala utställningen länkad ovan kan ni se de bästa bilderna tagna på de olika fotoplatserna under tävlingens gång. Stort tack igen till alla som deltog och grattis till de vinnande bidragen!")]), _vm._v(" "), _c('p', [_vm._v("Om du har några frågor kontakta oss på "), _c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "mailto:support@exhibitionstockholm.se"
    }
  }, [_c('u', [_vm._v("support@exhibitionstockholm.se")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lightroom-group"
  }, [_c('div', {
    staticClass: "text-group"
  }, [_c('div', {
    staticClass: "padding-80"
  }), _vm._v(" "), _c('div', {
    staticClass: "lightroom-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-40"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-black"
  }, [_vm._v("Skaffa"), _c('br'), _vm._v("Lightroom Mobile")]), _vm._v(" "), _c('div', {
    staticClass: "padding-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "body-dark-grey"
  }, [_vm._v("Vill du ta dina mobilbilder till nästa nivå? Lär dig grunderna i fotoredigering! Det är lättare än du kanske tror."), _c('br'), _c('br'), _vm._v("Här kan du gratis ladda ned appen Lightroom Mobile. Med Lightroom Mobile kan du enkelt både ta och redigera bilder i din telefon. Exhibition Stockholm ger dig vassa och pedagogiska tips på hur du kan använda Lightroom Mobile för att fota och redigera bilder som proffsen.")]), _vm._v(" "), _c('div', {
    staticClass: "padding-40"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08fb22ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Start.vue
// module id = 106
// module chunks = 0